import React, { Component } from 'react';
import moment from 'moment';
import { toast } from 'react-toastify';
import { DatePicker, DatePickerInput, Button } from 'carbon-components-react';
import StepCard from '../../StepCard';
import { pathDmService } from '../../../services/Api';



class ReceivingData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataBanco: "",
      nomeRecebedor: ""
    }
  }

  componentWillMount = () => {
    const { data } = this.props;
    this.setState({
      dataBanco: data.dataRetiradaUniforme,
      nomeRecebedor: data.retirouUniforme
    })
  }

  renderComponent = () => {
    const {dataBanco, nomeRecebedor} = this.state
    return (
      <div>
        <p>
          <strong>Retirado por:</strong>
          {' '}
          {nomeRecebedor}
        </p>
        <p>
          <strong>Data da Retirada:</strong>
          {' '}
          {moment(dataBanco).format("DD/MM/YYYY")}
  
        </p>
      </div>
    )
  }

  updateReceivingData = async () => {
    const { data } = this.props;
    const { nomeRecebedor, dataBanco } = this.state;

    const serviceUrl = `Pedido/AtualizaStatus/${data.id}?status=${data.status.id}&retirouUniforme=${nomeRecebedor}&dataRetiradaUniforme=${dataBanco}`;
    try {
      await pathDmService(serviceUrl, {});
      this.stepCardRef.toggleContent()
      await toast.success("Dados atualizados com sucesso");
    } catch (error) {
      console.log("error")
      console.log(error);
    }
  }

  onChangeText = event => {
    this.setState({
      nomeRecebedor: event.target.value
    });
  };

  onChangeDate = date => {
    const newDate = date ? moment(date[0]).format('YYYY-MM-DD HH:mm:ss') : date;    
    this.setState({
      dataBanco: newDate
    })
  };

  render() {
    const { data } = this.props;
    const {
      dataBanco,
      nomeRecebedor
    } = this.state;

    const dateCurrent = moment(dataBanco || new Date()).format("DD/MM/YYYY");

    return (
      <div>
        <StepCard
          onRef={(ref) => {
            this.stepCardRef = ref;
          }}
          title="Recebedor"
          description={this.renderComponent(data)}
          isFinished
        >
          <div className="v-sm-margin bx--col-md-3 bx--col-xs-12">
            <DatePicker
              id="date-pickerI"
              className=""
              datePickerType="single"
              dateFormat="d/m/Y"
              locale="pt"
              onChange={e => this.onChangeDate(e)}
              value={dateCurrent}
            >
              <div>
                <DatePickerInput
                  name="dataDesejada"
                  id="dataDesejada"
                  labelText="Data da entrega"
                  placeholder="dd/mm/aaaa"
                  onChange={e => this.onChangeDate(e)}
                  value={dateCurrent}
                />
              </div>
            </DatePicker>
          </div>
          <div className="v-sm-margin  bx--col-md-9 bx--col-xs-12">
            <label className="bx--label">
              Recebido por:
            </label>
            <input
              type="razaoSocial"
              className="bx--text-input"
              required
              placeholder="Nome do recebedor"
              name="razaoSocial"
              value={nomeRecebedor}
              onChange={this.onChangeText}
            />
          </div>
          <div className="v-md-margin mg-top-40">
            <Button onClick={() => this.updateReceivingData()}>Salvar</Button>
            <Button kind="ghost" className="h-sm-margin" onClick={() => this.stepCardRef.toggleContent()}>
              Cancelar
            </Button>
          </div>
        </StepCard>
      </div>
    )
  }
}

export default ReceivingData;



// WEBPACK FOOTER //
// ./src/components/trades/uniforms/ReceivingData.js